import { EditorView, basicSetup } from "codemirror";
import { keymap } from "@codemirror/view";
import { indentWithTab } from "@codemirror/commands";
import { languages } from "@codemirror/language-data";
import { LanguageSupport } from '@codemirror/language';
import internal from "stream";

class CodeMirrorComponent extends HTMLElement {
  static formAssociated = true;
  private view: EditorView | undefined;
  private internals: ElementInternals;

  constructor() {
    super();
    this.attachShadow({ mode: 'open' });
    this.internals = this.attachInternals();
  }

  async getLanguage(lang: string): Promise<LanguageSupport> {
    const langDescr = languages.find(l => l.alias.includes(lang));
    if (langDescr) {
      return await langDescr.load();
    } else {
      throw new Error(`Language ${lang} not found`);
    }
  }

  async connectedCallback() {

    const app = document.createElement('div');
    const language = this.getAttribute('language') || 'javascript';
    const langDef = await this.getLanguage(language);
    this.shadowRoot?.appendChild(app);

    const initialContent = this.innerHTML;
    this.internals.setFormValue(this.innerHTML);
    this.view = new EditorView({
      doc: initialContent,
      extensions: [
        basicSetup,
        keymap.of([indentWithTab]),
        langDef,
        EditorView.updateListener.of(update => {
          if (update.docChanged) {
            console.log("setFormValue", update.state.doc.toString());
            this.internals.setFormValue(update.state.doc.toString());
          }
        })
      ],
      parent: app
    });
  }

  get value(): string|undefined {
    return this.view?.state.doc.toString();
  }

  set value(newValue: string) {
    this.view?.dispatch({
      changes: { from: 0, to: this.view.state.doc.length, insert: newValue }
    });
  }
}

customElements.define('code-mirror', CodeMirrorComponent);